import React from "react";
import { NavLink } from "react-router-dom";
import schedule from "../schedule.json";
import Hero from "../components/Hero";

import scaimage1 from "../images/scaimage3.jpeg";
import scaimage2 from "../images/scaimage2.jpeg";
import scCover from "../images/sc_cover.jpg";
import alumCover from "../images/alum_cover.jpg";
import channelBanner from "../images/channel_banner.jpg";

const videoTiles = [
  {
    title: "Sand Cherry Way",
    href: "https://www.youtube.com/watch?v=tumz2DJpLIA",
    thumb: "https://img.youtube.com/vi/tumz2DJpLIA/hqdefault.jpg",
  },
  {
    title: "Workshop 2024",
    href: "https://youtu.be/qmupU0YCbww?si=Yi_CKiE2tp2frYud",
    thumb: "https://img.youtube.com/vi/qmupU0YCbww/hqdefault.jpg",
  },
  {
    title: "YouTube Channel",
    href: "https://www.youtube.com/@sandcherry6122/videos",
    thumb: channelBanner,
  },
  {
    title: "Workshop 2023",
    href: "https://youtu.be/HoQeGj6mRbI?si=0kHrFRBYwJh0qiWv",
    thumb: "https://img.youtube.com/vi/HoQeGj6mRbI/hqdefault.jpg",
  },
];

const HomePage = () => {
  const featuredHubs = schedule.hubs.slice(0, 3);

  return (
    <>
      <Hero />

      <div className="mt-6 flex w-full flex-col gap-8 px-4">
        <div className="flex w-full flex-col gap-6 md:flex-row">
          <NavLink
            to="/schedule"
            className="h-64 flex-1 transform overflow-hidden rounded-lg bg-cover bg-center shadow-lg transition hover:scale-105 md:h-72"
            style={{ backgroundImage: `url(${scaimage1})` }}
          >
            <div className="flex h-full flex-col items-center justify-center space-y-2 bg-black bg-opacity-40 p-4 text-center">
              <h2 className="text-2xl font-bold text-white sm:text-3xl">
                2026 Month of Service
              </h2>

              <p className="text-lg font-bold text-white">
                {schedule.timeframe}
              </p>

              <div className="space-y-2">
                {featuredHubs.map((hub) => (
                  <p
                    key={hub.id}
                    className="text-sm leading-5 text-white sm:text-base"
                  >
                    <span className="font-semibold">{hub.area}:</span>{" "}
                    {hub.captains.join(", ")}
                  </p>
                ))}
              </div>

              <p className="mt-2 font-bold text-white transition hover:text-stone-300">
                View volunteer hubs and the sign-up sheet
              </p>
            </div>
          </NavLink>

          <NavLink
            to="/directory"
            className="h-64 flex-1 transform overflow-hidden rounded-lg bg-cover bg-center shadow-lg transition hover:scale-105 md:h-72"
            style={{ backgroundImage: `url(${scaimage2})` }}
          >
            <div className="flex h-full flex-col justify-center bg-black bg-opacity-30 p-4">
              <h2 className="mb-2 text-center text-2xl font-bold text-white sm:text-3xl">
                Sand Cherry Directory
              </h2>

              <p className="text-center text-lg font-bold text-white transition hover:text-stone-300">
                Find colleagues by home base, role, and focus area
              </p>
            </div>
          </NavLink>
        </div>

        <div className="flex w-full flex-col gap-6 md:flex-row">
          <div
            className="h-64 flex-1 transform overflow-hidden rounded-lg bg-cover bg-center shadow-lg transition hover:scale-105 md:h-72"
            style={{ backgroundImage: `url(${scCover})` }}
          >
            <div className="flex h-full flex-col items-center justify-center space-y-4 bg-black bg-opacity-40 px-6 text-center">
              <h3 className="text-xl font-bold text-white sm:text-2xl">
                Stay Connected on LinkedIn
              </h3>

              <p className="max-w-md text-sm text-white sm:text-base">
                Follow Sand Cherry Associates and our Community &amp; Alumni
                Network.
              </p>

              <div className="flex w-full max-w-md flex-col justify-center gap-3 sm:flex-row">
                <a
                  href="https://www.linkedin.com/company/sand-cherry-associates/"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex flex-1 items-center justify-center rounded-full border border-white/80 bg-black/40 px-4 py-2 text-sm font-semibold text-white transition hover:bg-black/60 sm:text-base"
                >
                  Sand Cherry Associates
                </a>

                <a
                  href="https://www.linkedin.com/groups/12491163/"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex flex-1 items-center justify-center rounded-full border border-white/80 bg-black/40 px-4 py-2 text-sm font-semibold text-white transition hover:bg-black/60 sm:text-base"
                >
                  Community &amp; Alumni Network
                </a>
              </div>
            </div>
          </div>

          <div
            className="h-64 flex-1 transform overflow-hidden rounded-lg bg-cover bg-center shadow-lg transition hover:scale-105 md:h-72"
            style={{ backgroundImage: `url(${alumCover})` }}
          >
            <div className="flex h-full flex-col bg-black bg-opacity-55 px-4 py-4">
              <h3 className="mb-1 text-center text-xl font-bold text-white sm:text-2xl">
                Videos &amp; YouTube Channel
              </h3>

              <p className="mb-3 text-center text-xs text-white sm:text-sm">
                Watch the Sand Cherry Way, past workshops, and explore more on
                our channel.
              </p>

              <div className="mt-auto grid grid-cols-2 gap-2 sm:gap-3">
                {videoTiles.map((tile) => (
                  <a
                    key={tile.title}
                    href={tile.href}
                    target="_blank"
                    rel="noreferrer"
                    className="group relative flex min-h-[4.5rem] items-end justify-start overflow-hidden rounded-md sm:min-h-[5.5rem]"
                    style={{
                      backgroundImage: `linear-gradient(
                        to top,
                        rgba(0, 0, 0, 0.85),
                        rgba(0, 0, 0, 0.25)
                      ), url(${tile.thumb})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  >
                    <span className="relative z-10 px-2 py-1 text-[0.65rem] font-semibold text-white sm:text-xs">
                      {tile.title}
                    </span>

                    <div className="absolute inset-0 bg-black/10 transition group-hover:bg-black/0" />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomePage;
